// Geolocation Service factory function.
export default function GeolocationService($http, appSettings) {
  'ngInject';
  return {
    // GET /api/geolocation?ip=8.8.8.8
    getLocationByIp: function (ip) {
      if (!ip) {
        // If no IP param specified, used empty.
        ip = '';
      }

      const endpoint = `${appSettings.InReachApiEndpoint}/geolocation?ip=${ip}`;

      return $http.get(endpoint)
        .then(function (response) {
          // success
          return response.data;
        }, function (error) {
          // error
          return Promise.reject(error.statusText);
        });
    }
  };
}